import { Button, createStyles, Dialog, DialogActions, DialogContent, DialogTitle, Theme, withStyles } from '@material-ui/core';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import { transl } from '../../../main/transl';
import { mg } from '../../../mg/mg';
import { TemplDetailsStore } from './TemplDetailsStore';

function _TemplDetailsDialog(props: {store: Instance<typeof TemplDetailsStore>} & {classes: any}) {
	const {classes, store} = props;
	const lines = store.mainView;
	if (!lines.length) return null;
	return <Dialog open={true} className={classes.root} onClose={store.cancel} fullWidth>
		<DialogTitle>{transl('templDetails')}</DialogTitle>
		<DialogContent className={classes.content}>{
			lines.map(l => <Button fullWidth variant="outlined" color="primary" className={classes.line}
				name={l[0]} key={l[0]} onClick={store.onMainViewClick}>
				<div>{transl('edit' + mg.capitalize(l[0].toLowerCase()))}:</div>
				<div className={classes.spacing}/>
				<div>{l[1]}</div>
			</Button>)
		}</DialogContent>
		<DialogActions>
			<Button onClick={store.cancel}>{transl('cancel')}</Button>
		</DialogActions>
	</Dialog>;
}

const styles = createStyles((theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		width: '100%',
	},
	line: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'stretch',
		marginBottom: theme.spacing(1),
	},
	spacing: {
		flex: 1,
	}
}));

export const TemplDetailsDialog = withStyles(styles, {name: 'TemplDetailsDialog'})(observer(_TemplDetailsDialog));
